import { refreshAccessToken } from "../api/axios";

const useRefreshToken = () => refreshAccessToken;

export default useRefreshToken;
